import axios from 'axios'
import fetch from '@/utils/fetch'
// const apiConfig = require('../../static/config.json')
const apiUrl = window.Glob.BASE_URL;

export function remove(data) {
    return fetch({
      url: apiUrl + '/api/File/Remove?url='+data,
      method: 'post'
    })
  }


// WEBPACK FOOTER //
// ./src/api/fileApi.js